var _defs, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack4Solid09({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "8 1 0.64 6.35 3.45 15 12.55 15 15.36 6.35 8 1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44,11,6.9,10.8a1.07,1.07,0,0,0,.28.66.85.85,0,0,0,.6.22,1,1,0,0,0,.79-.43A3.65,3.65,0,0,0,9,9.46a1.8,1.8,0,0,1-1.42.66A2.13,2.13,0,0,1,6,9.41a2.62,2.62,0,0,1-.67-1.87A2.67,2.67,0,0,1,6,5.61a2.42,2.42,0,0,1,1.81-.73,2.46,2.46,0,0,1,2,.92,4.82,4.82,0,0,1,.77,3.05A4.89,4.89,0,0,1,9.75,12a2.62,2.62,0,0,1-2.09.95,2.19,2.19,0,0,1-1.49-.49A2.4,2.4,0,0,1,5.44,11Zm3.42-3.3a1.69,1.69,0,0,0-.34-1.13,1,1,0,0,0-.77-.4.87.87,0,0,0-.7.33,1.71,1.71,0,0,0-.28,1.08,1.72,1.72,0,0,0,.3,1.12A.94.94,0,0,0,7.83,9a.93.93,0,0,0,.73-.35A1.49,1.49,0,0,0,8.86,7.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack4Solid09);
export default __webpack_public_path__ + "static/media/Symbolpack_4_solid_09.7b9783e7f01a3d9ffc833bf9ff4143fc.svg";
export { ForwardRef as ReactComponent };